import type { InputHTMLAttributes, ReactNode, SelectHTMLAttributes } from 'react'

/**
 * Поле формы: подпись + контрол + подсказка/ошибка.
 * Блок `div.field > label.field__label > input.input` повторяется в формах
 * бекофиса больше 160 раз.
 */
export function Field({
  label,
  htmlFor,
  hint,
  full,
  children,
  className
}: {
  label?: ReactNode
  htmlFor?: string
  hint?: ReactNode
  /** Растянуть на всю ширину form-grid. */
  full?: boolean
  children: ReactNode
  className?: string
}): React.JSX.Element {
  const cls = ['field', full ? 'field--full' : '', className ?? ''].filter(Boolean).join(' ')
  return (
    <div className={cls}>
      {label != null && (
        <label className="field__label" htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {hint != null && <div className="field__hint">{hint}</div>}
    </div>
  )
}

/** `<input class="input">`. */
export function Input({
  className,
  ...rest
}: InputHTMLAttributes<HTMLInputElement>): React.JSX.Element {
  return <input className={['input', className ?? ''].filter(Boolean).join(' ')} {...rest} />
}

/** `<select class="input">`. */
export function Select({
  className,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement>): React.JSX.Element {
  return (
    <select className={['input', className ?? ''].filter(Boolean).join(' ')} {...rest}>
      {children}
    </select>
  )
}

/** Чекбокс с подписью в одну строку. */
export function Checkbox({
  checked,
  onChange,
  disabled,
  children
}: {
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  children: ReactNode
}): React.JSX.Element {
  return (
    <label className="checkbox">
      <input
        type="checkbox"
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      />
      {children}
    </label>
  )
}

/** Текст ошибки формы под полями. */
export function FormError({ children }: { children: ReactNode }): React.JSX.Element {
  return <div className="form-error form-error--gap">{children}</div>
}
